import { Link } from 'react-router-dom';
import { MdArrowForward } from 'react-icons/md';
import type { NavItem, NavSection } from '@components/layout/nav.config';

interface Props {
  section: NavSection;
  item: NavItem;
}

export function ModuleCard({ section, item }: Props) {
  const Icon = item.icon;
  const disabled = Boolean(item.comingSoon);

  const cardClasses = [
    'group relative flex h-full flex-col overflow-hidden rounded-xl border bg-surface p-5 transition',
    disabled
      ? 'cursor-not-allowed border-border opacity-70'
      : 'border-border hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-elevated',
  ].join(' ');

  const inner = (
    <>
      {disabled && (
        <span className="absolute right-4 top-4 rounded-full bg-primary/[0.06] px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-[0.18em] text-primary ring-1 ring-primary/15">
          Soon
        </span>
      )}

      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-primary/[0.08] text-primary ring-1 ring-primary/10">
        <Icon size={22} />
      </div>

      <p className="mb-1 text-[10.5px] font-medium uppercase tracking-[0.2em] text-foreground-muted">
        {section.label}
      </p>
      <h3 className="text-[16.5px] font-semibold tracking-tight text-foreground">
        {item.label}
      </h3>
      {item.description && (
        <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-muted">
          {item.description}
        </p>
      )}

      <div className="mt-auto pt-5">
        {disabled ? (
          <span className="inline-flex items-center gap-1 text-[12.5px] font-medium text-foreground-muted">
            Not yet available
          </span>
        ) : (
          <span className="inline-flex items-center gap-1 text-[12.5px] font-medium text-primary transition-transform duration-150 group-hover:translate-x-0.5">
            Open <MdArrowForward size={14} />
          </span>
        )}
      </div>
    </>
  );

  if (disabled) {
    return (
      <div
        className={cardClasses}
        aria-disabled
        role="button"
        tabIndex={-1}
        title={`${item.label} — coming soon`}
      >
        {inner}
      </div>
    );
  }

  return (
    <Link to={item.to} className={cardClasses}>
      {inner}
    </Link>
  );
}
